<script lang="ts" setup>
import {
  GrammarModal,
  GrammarRadioButtonGroup,
  GrammarRadioButtonItem,
} from '@nora-monorepo/grammar-ui';
import { DarkMode, useDarkModeStore } from '@nora-monorepo/ui-shared';

interface Props {
  isOpen: boolean;
}

defineProps<Props>();

const darkModeStore = useDarkModeStore();

function changeMode(value: string) {
  darkModeStore.setDarkMode(value);
}
</script>

<template>
  <GrammarModal :is-open="isOpen" label="Theme" :show-close-button="true">
    <template #content>
      <GrammarRadioButtonGroup
        :selected-value="darkModeStore.darkMode"
        @input="changeMode"
      >
        <GrammarRadioButtonItem :value="DarkMode.Light" label="Light mode" />
        <GrammarRadioButtonItem :value="DarkMode.Dark" label="Dark mode" />
        <GrammarRadioButtonItem
          :value="DarkMode.System"
          label="System default"
        />
      </GrammarRadioButtonGroup>
    </template>
    <template #footer>
      <span>&nbsp;</span>
    </template>
  </GrammarModal>
</template>
